import { MondayLogo } from "frontend/icons/monday-logo";
import UpgradeModalGeneric, { UpgradeModalNeededProps } from "./upgrade-modal";
import { getPathPrefix } from "../../utils/getPathPrefix";

export default function UpgradeModalForMondayIntegrationLimit(props: UpgradeModalNeededProps) {
  return (
    <UpgradeModalGeneric
      trackingEvent="monday-integration-limit"
      title={
        <span>
          Unlimited <MondayLogo height={9} width={14} /> <b>monday</b>
          <small>.com</small> items
        </span>
      }
      content={
        "Keep your ideas and execution aligned with unlimited synced items between your canvas and monday boards."
      }
      bulletpoints={[
        "Blazing fast multiplayer",
        "Task management",
        "Commenting",
        "A world of templates",
        "Quality file export",
      ]}
      image={getPathPrefix("/images/upgrade-modal-images/upgrade-for-monday-integration.png")}
      {...props}
    />
  );
}
